import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CATEGORY_FAVORITES_FEATURE_KEY, CategoryFavoritesState } from './category-favorite.reducer';

export const selectCategoryFavoritesState =
  createFeatureSelector<CategoryFavoritesState>(CATEGORY_FAVORITES_FEATURE_KEY);

export const selectCategoryFavorites = createSelector(
  selectCategoryFavoritesState,
  (state: CategoryFavoritesState) => state.categoryFavorites
);

export const selectCategoryFavoritesLoaded = createSelector(
  selectCategoryFavoritesState,
  (state: CategoryFavoritesState) => state.loaded
);

export const selectCategoryFavoritesError = createSelector(
  selectCategoryFavoritesState,
  (state: CategoryFavoritesState) => state.error
);
